// extracted by mini-css-extract-plugin
export default {"TitleBar":"style_TitleBar__bNnre","content":"style_content__v2-Uc","item":"style_item__51YQw","title":"style_title__7dtO7","back":"style_back__hmAcl"};